import React, { lazy, Suspense, useState } from "react";
import { useAppSelector } from '../../store/hooks';
import { selectStudioCache } from '../../store/studioCacheSlice';
import StudioEmptyWorkspace, { StudioSidebarLoading } from "./StudioEmptyWorkspace";
import StudioNavigation from "./StudioNavigation";
import { readStudioPanels } from "./useStudioPreferences";

/** The same shell before the route, account, and workspace data are ready. */
const CachedSidebar = lazy(() => import('./StudioCachedSidebar'));
export default function StudioRouteLoading({ label, showCachedSidebar = true }: { label?: string; showCachedSidebar?: boolean }) {
  const cache = useAppSelector(selectStudioCache);
  // Read layout preferences without writing an empty workspace over saved tree state.
  const [panels] = useState(readStudioPanels);
  return <StudioNavigation>{({ onOpenNavigation }) => (
    <StudioEmptyWorkspace panels={showCachedSidebar && cache?.data.layout.panels || panels} label={label} onOpenNavigation={onOpenNavigation}
      sidebar={showCachedSidebar && cache && <Suspense fallback={<StudioSidebarLoading />}><CachedSidebar /></Suspense>} />
  )}</StudioNavigation>;
}
